import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user-service/user.service';

@Component({
  selector: 'app-users-users-breadcrumb-card',
  templateUrl: './users-users-breadcrumb-card.component.html',
  styleUrls: ['./users-users-breadcrumb-card.component.scss']
})
export class UsersUsersBreadcrumbCardComponent implements OnInit {

  viewDisposition;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private userService: UserService) {
                this.viewDisposition = 'grid';
              }

  ngOnInit() { }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.userService.toggleUserDisposition(viewDis);
  }

  public createUser() {
    this.router.navigate(['../../user'], {relativeTo: this.activatedRoute});
  }

  public search(event) {
    this.userService.searchUsers(event.target.value);
  }

}
